const COLOURS = {
  RoyalPurple: '#713BDB',
  ElyriaRed: '#CB2C31',
  DatavistaBlue: '#30ACBB',
  SejutaKGPurple: '#27235d',
  LightRed: '#E06C6F',
  PortalGrey: '#808191',
  White: '#FFFFFF',
  Dark: '#15112D',
  MediumGrey: '#515263',
  LightPurple: '#9F97BF',
  LightGreen: '#A8C62B',
  GoodGreen: '#33D69F',
  Orange: '#F45F09',
  AlertOrange: '#FD8B57',
};

export default COLOURS;
